import {createAction, props} from '@ngrx/store';
import {Role, Tokens} from '../../models';

export const authDPIRedirect = createAction('[Auth] DPI Redirect');
export const authLDAPRedirect = createAction('[Auth] LDAP Redirect');

export const authLoginRequest = createAction(
  '[Auth] Login Request',
  props<{ access_token: string, authType?: string }>()
);

export const authLoginLDAPRequest = createAction(
  '[Auth] Login LDAP Request',
  props<{ personaId: string }>()
);

export const authLoginFREERequest = createAction(
  '[Auth] Login FREE Request',
  props<{ personaId: string }>()
);

export const authAccessTokenRequest = createAction(
  '[Auth] Access Token Request',
  props<{ code: string, authType: string }>()
);

export const authAccessTokenSuccess = createAction(
  '[Auth] Access Token Success',
  props<{ tokens: Tokens, authType?: string }>()
);

export const authAccessTokenFailure = createAction(
  '[Auth] Access Token Failure',
  props<{ error: string }>()
);

export const authLoginSuccess = createAction(
  '[Auth] Login Success',
  props<{ personaId: string, authType?: string }>()
);

export const authLoginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string }>()
);

export const authRedirect = createAction(
  '[Auth] Redirect',
  props<{ url: string }>()
);

export const authPutRoleSuccess = createAction(
  '[Auth] Put Role Success',
  props<{ role: Role }>()
);

export const authLogout = createAction(
  '[Auth] Logout'
);

export const authLogoutSuccess = createAction(
  '[Auth] Logout Success',
  props<{ isLoading: boolean }>()
);

export const authLogoutFailure = createAction(
  '[Auth] Logout Failure'
);
